var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56467 6.00093L7.58331 3.05454V16.1053C7.58331 16.5992 7.99399 17 8.5 17C9.00601 17 9.41669 16.5992 9.41669 16.1053V3.05454L12.4353 6.00093C12.6141 6.17585 12.8488 6.26309 13.0834 6.26309C13.3181 6.26309 13.5528 6.17585 13.7315 6.00093C14.0895 5.65153 14.0895 5.08516 13.7315 4.73576L9.1481 0.262048C8.79059 -0.0873493 8.20941 -0.0873493 7.8519 0.262048L3.26847 4.73576C2.91051 5.08516 2.91051 5.65153 3.26847 6.00093C3.62598 6.35032 4.20716 6.35032 4.56467 6.00093Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 14C16.6032 14 16.2 14.392 16.2 14.875V18.375C16.2 18.8576 15.7964 19.25 15.3 19.25H2.7C2.20365 19.25 1.8 18.8576 1.8 18.375V14.875C1.8 14.392 1.3968 14 0.9 14C0.4032 14 0 14.392 0 14.875V18.375C0 19.8227 1.21095 21 2.7 21H15.3C16.7891 21 18 19.8227 18 18.375V14.875C18 14.392 17.5968 14 17.1 14Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.fe9a9a63ce6fe44805d7e3012ba66861.svg";
export { ForwardRef as ReactComponent };